var jcrew = {
    actionButton: {
        text: 'shopMore.jCrewButtonText',
        link: 'https://www.jcrew.com/'
    },
    certificateBalance: true,
    certificateExpirationDays: null,
    certificateValue: null,
    disclaimerTranslationKey: null,
    en: {
        termsAndConditionsLink: 'https://www.jcrew.com/company/rewards-terms-and-conditions'
    },
    es: {
        termsAndConditionsLink: 'https://www.jcrew.com/company/rewards-terms-and-conditions'
    },
    howToEarnPointsHeader: 'fullDetailsPage.jCrewHowToEarnPointsHeader',
    faqs: null,
    faqsSnapshot: true,
    isRewardTiers: false,
    isValuePropBanner: true,
    links: [],
    translationKey: 'faqs.description',
    snapshotTranslationKey: 'faqs.description',
    translationViewPrintKey: null,
    DUAL_CARD: {
        banner: 'jcrew-dc-banner.png',
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {
                gas: { icon: ['far', 'gas-pump'] },
                grocery: { icon: ['far', 'basket-shopping'] },
                world: { icon: ['far', 'earth-america'] },
                bonus: { icon: ['far', 'money-bills'] },
                adjustment: {
                    icon: ['far', 'calculator']
                }
            },
            titleKey: 'jCrewEarnings.yourJcrewEarnings'
        },
        rewardsBalance: true,
        valuePropImg: 'jcrew-valueProp-dc.png',
        en: {
            disclaimer: "Points that aren't converted into rewards will expire 365 days after issued on a rolling basis. Points converted to rewards will be removed from the points balance. J.Crew Passport Rewards expire 90 days after issued.",
            propositions: [
                {
                    description: 'Earn 7.5% back for J.Crew Passport Gold Tier (Equals 3 points per $1 spent)*',
                    heading: 'earn',
                    points: '7.5% back'
                },
                {
                    description: 'Earn 5% back for J.Crew Passport Navy Tier (Equals 2 points per $1 spent)*',
                    heading: 'earn',
                    points: '5% back'
                },
                {
                    description: 'Earn 2.5% back on Gas & Grocery Store purchases. (Equals 1 point per $1 spent)*',
                    heading: 'earn',
                    points: '2.5% back'
                },
                {
                    description: 'Earn 1.25% back on all other purchases.\n(Equals 1 point per $2 spent)*',
                    heading: 'earn',
                    points: '1.25% back'
                }
            ]
        },
        es: {
            disclaimer: 'Los puntos que no se conviertan en recompensas vencerán 365 días después de su emisión de forma continua. Los puntos convertidos en recompensas se eliminarán del saldo de puntos. Las recompensas de J.Crew Passport vencerán 90 días después de su emisión.',
            propositions: [
                {
                    description: 'Obtenga 7.5% de reembolso por ser Nivel Gold de J.Crew Passport (Igual a 3 puntos por $1 gastado)*',
                    heading: 'obtenga',
                    points: '7.5% de reembolso'
                },
                {
                    description: 'Obtenga 5% de reembolso por ser Nivel Navy de J.Crew Passport (Igual a 2 puntos por $1 gastado)*',
                    heading: 'obtenga',
                    points: '5% de reembolso'
                },
                {
                    description: 'Obtenga 2.5% de reembolso en compras de Gasolina y Supermercado (Igual a 1 punto por cada $1 gastado)*',
                    heading: 'obtenga',
                    points: '2.5% de reembolso'
                },
                {
                    description: 'Obtenga el 1.25% de reembolso en todas las demás compras.\n(Equivale a 1 punto por cada $2 que gaste)*',
                    heading: 'obtenga',
                    points: '1.25% de reembolso'
                }
            ]
        }
    },
    PRIVATE_LABEL: {
        banner: 'jcrew-plcc-banner.png',
        certificateHistoryImg: '',
        certificateHistory: false,
        perks: [
            {
                icon: ['far', 'box-circle-check'],
                titleTranslationKey: 'freeStandardShippingTitle',
                descriptionTranslationKey: 'freeStandardShippingDescription'
            },
            {
                icon: ['far', 'cake-candles'],
                titleTranslationKey: 'birthdaySurprisesTitle',
                descriptionTranslationKey: 'birthdaySurprisesDescription'
            },
            {
                icon: ['far', 'clothes-hanger'],
                titleTranslationKey: 'bonusPointsDaysTitle',
                descriptionTranslationKey: 'bonusPointsDaysDescription'
            }
        ],
        rewardsBalance: false,
        valuePropImg: 'jcrew-valueProp-plcc.png',
        en: {
            disclaimer: "Points that aren't converted into rewards will expire 365 days after issued on a rolling basis. Points converted to rewards will be removed from the points balance. J.Crew Passport Rewards expire 90 days after issued. For every 200 points you earn, get $5.00 in Rewards.*",
            propositions: [
                {
                    description: 'Earn 7.5% back for J.Crew Passport Gold Tier (Equals 3 points per $1 spent)*',
                    heading: 'earn',
                    points: '7.5% back'
                },
                {
                    description: 'Earn 5% back for J.Crew Passport Navy Tier (Equals 2 points per $1 spent)*',
                    heading: 'earn',
                    points: '5% back'
                }
            ]
        },
        es: {
            disclaimer: 'Los puntos que no se conviertan en recompensas vencerán 365 días después de su emisión de forma continua. Los puntos convertidos en recompensas se eliminarán del saldo de puntos. Las recompensas de J.Crew Passport vencerán 90 días después de su emisión. Por cada 200 puntos que obtenga, recibirá $5.00 en Recompensas*',
            propositions: [
                {
                    description: 'Obtenga 7.5% de reembolso por ser Nivel Gold de J.Crew Passport (Igual a 3 puntos por $1 gastado)*',
                    heading: 'obtenga',
                    points: '7.5% de reembolso'
                },
                {
                    description: 'Obtenga 5% de reembolso por ser Nivel Navy de J.Crew Passport (Igual a 2 puntos por $1 gastado)*',
                    heading: 'obtenga',
                    points: '5% de reembolso'
                }
            ]
        }
    }
};
export default jcrew;
